import React from "react"

const Arrow = () => {
    return (
        <img src="right-arrow.svg" alt="" width="100px"/>
    )
}

export default Arrow